import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  ListGroup
} from 'react-bootstrap'
import { LeftSidebarView } from 'components/Sidebar'
import {
  ListItem
} from 'components/List'
import KanBoIcon from 'components/KanBoIcon'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import UserSettingsGeneral from './components/UserSettingsGeneral'
import Notifications from './components/Notifications'

export class UserSettings extends React.Component {
  static propTypes = {
    leftSidebar: PropTypes.object.isRequired
  }

  handleCloseClick = () => {
    this.props.leftSidebar.close()
  }

  handleSettingsGeneralClick = () => {
    this.props.leftSidebar.push(UserSettingsGeneral)
  }

  handleNotificationsClick = () => {
    this.props.leftSidebar.push(Notifications)
  }

  render () {
    return (
      <LeftSidebarView
        title={<FormattedMessage id='USER_SETTINGS' />}
      >
        <ListGroup>
          <ListItem
            borderedIcon
            icon={<KanBoIcon fixedWidth name='kanbo-16-settings' />}
            onClick={this.handleSettingsGeneralClick}
          >
            <FormattedMessage id='GENERAL' />
          </ListItem>
          <ListItem
            borderedIcon
            icon={<KanBoIcon fixedWidth name='kanbo-16-notifications' />}
            onClick={this.handleNotificationsClick}
          >
            <FormattedMessage id='USER_SETTINGS_NOTIFICATION' />
          </ListItem>
        </ListGroup>
      </LeftSidebarView>
    )
  }
}

export default withLeftSidebar(UserSettings)
